/* Post-checkout cleanup for the Kasa17 headless checkout.

   The Kasa17 checkout completes the order on its own (Vercel) domain. Shopify's
   native checkout would empty the storefront cart on completion, but the
   headless flow never touches the cart cookie on durnevshop.com.ua — so the
   buyer comes back to a still-full cart and can't tell whether the order went
   through.

   Contract: after a SUCCESSFUL order, Kasa17 redirects the buyer back to the
   store with `?order_placed=<order_name>` (value optional — `1` also works).
   On seeing that flag we:
     1. clear the Shopify cart  (/cart/clear.js)
     2. refresh the header bag count + side drawer to the empty state
     3. show a thank-you banner so the buyer has on-store confirmation even if
        their email address was mistyped
     4. strip the flag from the URL so a refresh doesn't re-trigger

   NOTE: the Kasa17 snippet also clears the cart (via ?kasa17_cart_cleared).
   Double-clear is safe — both hit the same idempotent /cart/clear.js. This
   file additionally shows the on-store thank-you banner, which the snippet
   does not.
*/
(function () {
  var params = new URLSearchParams(window.location.search);
  var placed =
    params.get('order_placed') ||
    params.get('ksa_order') ||
    params.get('order') ||
    params.get('thank_you');
  if (!placed) return;

  function refreshHeaderAndDrawer() {
    return fetch('/', { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshBag = doc.querySelector('.durnev-header__bag-count, [data-cart-count]');
        var curBag = document.querySelector('.durnev-header__bag-count, [data-cart-count]');
        if (freshBag && curBag) curBag.textContent = freshBag.textContent;
        var freshCart = doc.getElementById('overlay-cart');
        var curCart = document.getElementById('overlay-cart');
        if (freshCart && curCart) curCart.replaceWith(freshCart);
      })
      .catch(function () {});
  }

  function showBanner() {
    try {
      var bar = document.createElement('div');
      bar.className = 'durnev-order-confirm';
      bar.setAttribute('role', 'status');
      var num = placed && placed !== '1' ? ' № ' + placed : '';
      bar.innerHTML =
        '<span class="durnev-order-confirm__check" aria-hidden="true">✓</span>' +
        '<span>Дякуємо! Ваше замовлення' + num +
        ' оформлено. Лист із підтвердженням надіслано на вашу пошту.</span>';
      document.body.appendChild(bar);
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      setTimeout(function () { bar.classList.remove('is-visible'); }, 9000);
    } catch (e) {}
  }

  function stripFlag() {
    if (!window.history || !window.history.replaceState) return;
    // Re-read the CURRENT search params (not the snapshot captured at load):
    // the kasa17 snippet may have already stripped its own
    // ?kasa17_cart_cleared marker, and we must not resurrect it.
    var cur = new URLSearchParams(window.location.search);
    ['order_placed', 'ksa_order', 'order', 'thank_you'].forEach(function (k) { cur.delete(k); });
    var qs = cur.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  }

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
    body: '{}'
  })
    .then(refreshHeaderAndDrawer)
    .catch(function () {})
    .finally(function () {
      showBanner();
      stripFlag();
    });
})();
